// extracted by mini-css-extract-plugin
export default {"root":"coppy-button_root__vQfb2","svg":"coppy-button_svg__hbEq+","postText":"coppy-button_postText__4F7ti"};